import { createResourceCollection } from '@/request'
import { ProgramReward } from '@/types/program-rewards/program-rewards'

export const publicProgramRewardsCollection =
  createResourceCollection<ProgramReward>({
    name: 'publicProgramRewards',
    apiConfig: {
      path: 'program_rewards',
      public: true,
    },
    selector: (state) => state.publicProgramRewards,
  })

export const publicProgramRewardsReducer =
  publicProgramRewardsCollection.slice.reducer
